var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.55556 12H9.33333V13.6H7.55556V12Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.55556 15.2H9.33333V16.8H7.55556V15.2Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8889 12H11.1111V13.6H12.8889V12Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1111 15.2H12.8889V16.8H11.1111V15.2Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4444 12H14.6667V13.6H16.4444V12Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6667 15.2H16.4444V16.8H14.6667V15.2Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.2222 20H5.77778C4.79733 20 4 19.2824 4 18.4V7.2C4 6.3176 4.79733 5.6 5.77778 5.6H7.55556V4H9.33333V5.6H14.6667V4H16.4444V5.6H18.2222C19.2027 5.6 20 6.3176 20 7.2V18.4C20 19.2824 19.2027 20 18.2222 20ZM18.2224 8.8L18.2222 7.2H5.77778V8.8H18.2224ZM18.2225 10.4L18.2231 18.4H5.77778V10.4H18.2225Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarIcon);
export default __webpack_public_path__ + "static/media/calendarIcon.30282c52ff7d8e0bc932180475f7f885.svg";
export { ForwardRef as ReactComponent };